// Raw-row helpers shared by the model: every row's day is the local date part
// of its `date` (symptoms send `YYYY-MM-DD`, bowel movements a local datetime).

/** `YYYY-MM-DD` of a symptom or bowel row. */
export const logDate = (row) => String(row?.date ?? '').slice(0, 10);

/** The earliest day with a gut symptom or bowel row, or null when there is none. */
export function firstLogDate({ symptoms = [], bowel = [] }) {
  const days = [...symptoms, ...bowel].map(logDate).filter(Boolean).sort();
  return days[0] ?? null;
}
